import React, { useEffect } from 'react';
import {
    Grid, Menu, Breadcrumb, Tab, Label, Icon, Loader, Dimmer, Segment
} from 'semantic-ui-react'
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { pgtoWebListAction } from '../../actions/PgtoWebActions';
import ListaTransacao from './ListaTransacao';

function PgtoWeb(props) {

    const { pgtoweblist, isloading, pgtoWebListAction, } = props;

    let panes = [
        {
            menuItem: <Menu.Item key='TABpendente'><Icon name='money bill alternate outline' />Transações <Label color='green'>{isloading === true ? (
                <Loader active inline size='mini' inverted />
            ) : (
                pgtoweblist[0]?.total_transacoes
            )}</Label></Menu.Item>,
            render: () =>
                <ListaTransacao />,
        },
    ]

    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Pagamento Web</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>
            <div>
                <Grid columns={1} doubling>
                    <Grid.Column>
                        <Tab panes={panes} />
                    </Grid.Column>
                </Grid>
            </div>

            <style>{`

                /*-------------------------------*/
                /*Menu Superior*/


                .ui.mini.menu>.item{
                    padding: 0;
                }

                .ui.breadcrumb .section {
                    padding: 1.5em 1.5em !important;
                }
                
                .ui.breadcrumb .section:first-child {
                    padding-right: 0 !important;
                    border-radius: 0 0 0 5px !important;
                }
                    

                .ui.breadcrumb .active.section {
                    background-color: #1884af !important;
                    color: #fff !important;
                }
            `}</style>

        </div>
    );
}

const mapStateToProps = (state) => ({
    pgtoweblist: state.PgtoWebReducer.pgtoweblist,
    isloading: state.PgtoWebReducer.isloading,
    vendedorvcc: state.LoginReducer.vendedorvcc
})
export default withRouter(connect(mapStateToProps, {
    pgtoWebListAction
}
)(PgtoWeb));